var _defaultValues;
import { NEWSLETTER } from "./field-names";
export var defaultValues = (_defaultValues = {}, _defaultValues[NEWSLETTER] = true, _defaultValues);
